import React from 'react';

const SkeletonCard = () => (
    <div className="bg-white p-4 rounded-xl shadow-md animate-pulse">
        <div className="flex items-center justify-between">
            <div>
                <div className="h-5 bg-gray-300 rounded w-32 mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-24"></div>
            </div>
            <div className="h-6 w-20 bg-gray-200 rounded-full"></div>
        </div>
        <div className="mt-4 pt-3 border-t flex justify-between items-center">
            <div className="h-4 bg-gray-200 rounded w-16"></div>
            <div className="h-6 w-24 bg-gray-300 rounded-full"></div>
        </div>
    </div>
);


export default function SkeletonLoader({ count = 3 }) {
    return (
        <div className="space-y-4">
            {Array.from({ length: count }).map((_, i) => (
                <SkeletonCard key={i} />
            ))}
        </div>
    );
}
